import { optional, required } from 'AppReact/schema';

export const badge = {
  image: required('string'),
  name: required('string'),
  description: required('string'),
  receiveDate: optional('jsDate'),
  hasStats: optional('boolean'),
  achieved: optional('integer'),
  onTrack: optional('integer'),
  progress: optional('number'),
  progressText: optional('string'),
}